import React, { useState } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import GameStopSideBar from "./../GameStopSideBar/GameStopSideBar";
import "./GameStopsIntermediary.scss";
import gameStopLogo1 from "./../../assets/img/gamestop-1.png";
import gameStopLogo2 from "./../../assets/img/gamestop-2.png";
import gameStopLogo3 from "./../../assets/img/gamestop-3.png";
import gameStopLogo4 from "./../../assets/img/gamestop-4.png";
import gameStopLogo5 from "./../../assets/img/gamestop-5.png";
import gameStopLogo6 from "./../../assets/img/gamestop-6.png";
import gameStopLogo7 from "./../../assets/img/gamestop-7.png";
import gameStopLogo8 from "./../../assets/img/gamestop-8.png";
import Header from "./../Header/Header";
import AboutGameScoreModal from "./../AboutGameScore/AboutGameScoreModal";

const GAME_STOPS = [
	{
		gameStopTitle: "Saddle Up-Oregon State Fair Campaign Launch.",
		gameStopDescription: (
			<h2>
				You are making the big announcement: you're running with a promise to represent the views of the people.
				The speech needs to address the biggest problems on voters' minds - and you need to be ready for the
				press to ask questions about the fiercest debates in the race. Topics could include a Most Important
				Problem - or almost{" "}
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/data-highlights/topics-glance">
					anything else
				</a>
				! Do you have the data to reach the most voters?
			</h2>
		),
		gameStopLogo: gameStopLogo1,
	},
	{
		gameStopTitle: "Theodore Roosevelt High School - High School Graduation.",
		gameStopDescription: (
			<h2>
				You will address the graduating class of Theodore Roosevelt High School in Wilton, Wyoming. Topics
				include
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/environment">
					{" "}
					Environment
				</a>
				,
				<a target="_blank" rel="noopener noreferrer" href="https://ropercenter.cornell.edu/topics-glance/guns">
					{" "}
					Guns
				</a>
				, Drugs, and
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/education">
					{" "}
					Education
				</a>
				. Do you have the data to reach the youth?
			</h2>
		),
		gameStopLogo: gameStopLogo2,
	},
	{
		gameStopTitle: "The Elizabeth Cady Stanton Society for the Advancement of Women.",
		gameStopDescription: (
			<h2>
				You are keynote speaker for The Elizabeth Cady Stanton Society for the Advancement of Women's annual
				meeting. Topics include{" "}
				<a target="_blank" rel="noopener noreferrer" href="https://ropercenter.cornell.edu/topics-glance/women">
					Women{" "}
				</a>
				in the Workforce, Women's Role in Society, and Women's Health. Do you have the data to reach women
				voters?
			</h2>
		),
		gameStopLogo: gameStopLogo3,
	},
	{
		gameStopTitle: "Going Down into the Mine Laborer's Union.",
		gameStopDescription: (
			<h2>
				You will put on a pair of ill-fitting overalls and be addressing the Mine Laborer's Union. Topics to
				include
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/work-and-labor">
					{" "}
					Labor
				</a>
				,
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/environment">
					{" "}
					Environment
				</a>
				, and
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/health">
					{" "}
					Health
				</a>
				. Do you have the data to reach the labor block?
			</h2>
		),
		gameStopLogo: gameStopLogo4,
	},
	{
		gameStopTitle: "Fort America Army Base.",
		gameStopDescription: (
			<h2>
				You will salute the troops at Fort America. Topics to be covered will be:{" "}
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/defense-spending">
					Defense Spending{" "}
				</a>
				and{" "}
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/us-role-world">
					US Role in the World
				</a>
				. Do you have the data to reach the members of the military?
			</h2>
		),
		gameStopLogo: gameStopLogo5,
	},
	{
		gameStopTitle: "Businesspeople for More Businesslike Business Luncheon.",
		gameStopDescription: (
			<h2>
				You will speak to the largest business lunch ever convened. Topics addressed include
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/economy">
					{" "}
					Economy
				</a>
				,
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/immigration">
					{" "}
					Immigration
				</a>
				,
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/role-government">
					{" "}
					Role of Government
				</a>
				. Do you have the data to reach the business voters?
			</h2>
		),
		gameStopLogo: gameStopLogo7,
	},
	{
		gameStopTitle: "Mic Drop: Time to Debate!",
		gameStopDescription: (
			<h2>
				You need to prepare for a{" "}
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/blog/podiums-platforms-and-polls-public-opinion-election-debates">
					head to head showdown{" "}
				</a>
				in front of a national audience. Do you have the data to reach the most voters?
			</h2>
		),
		gameStopLogo: gameStopLogo6,
	},
	{
		gameStopTitle: "Shady Grove Senior Living Early Bird Breakfast.",
		gameStopDescription: (
			<h2>
				Get up early to address senior voters. Topics include{" "}
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/health">
					Health Care{" "}
				</a>
				and{" "}
				<a
					target="_blank"
					rel="noopener noreferrer"
					href="https://ropercenter.cornell.edu/topics-glance/seniors">
					Seniors
				</a>
				.
			</h2>
		),
		gameStopLogo: gameStopLogo8,
	},
];

function GameStopsIntermediary(props) {
	const gameStopTitle = GAME_STOPS[props.gameState.gameStopNumber - 1].gameStopTitle; //CAPTIONS ARE 0-BASED AND gameStopNumber ARE 1-BASED
	const gameStopDescription = GAME_STOPS[props.gameState.gameStopNumber - 1].gameStopDescription;
	const gameStopImg = GAME_STOPS[props.gameState.gameStopNumber - 1].gameStopLogo;

	// currentNumber is 0 because game hasn't started for that game stop number

	const [isModalOpen, setIsModalOpen] = useState(false);

	const openModal = () => {
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setIsModalOpen(false);
	};
	return (
    <div className="game-stop-transition-container">
      <AboutGameScoreModal isOpen={isModalOpen} isClose={closeModal} />
      <div className="header-img">
        <Header onButtonClick={openModal} timeline={props.gameState.timeline} score={props.gameState.score}/>
      </div>
      <Grid container>
        <Grid item xs={1}>
          <div className="sticky-game-stop-bar">
            <GameStopSideBar
              gameStopNumber={props.gameState.gameStopNumber}
              currentNumber={0}
            />
          </div>
        </Grid>

        <Grid
          item
          xs={11}
          className="container"
          role="region"
          aria-label="Campaign Stop">
          <h1 className="campaign-text">Campaign Stop </h1>
          <h2 className="campaign-text-h2">{gameStopTitle}</h2>
          <div className="game-stop-description">{gameStopDescription}</div>
          <img
            className="game-stop-logo"
            src={gameStopImg}
            alt={"Game Stop logo"}
          />
          <div className="lock-in-btn-wrapper">
            <Button
              className="button-primary next-campaign-stop-btn"
              onClick={() =>
                props.navigate(1, {
                  score: props.gameState.score,
                  timeline: props.gameState.timeline,
                  gameStopNumber: props.gameState.gameStopNumber,
                  firstPercentageGuess: props.gameState.firstPercentageGuess,
                  firstRankAll: props.gameState.firstRankAll,
                  firstTop1: props.gameState.firstTop1,
                  firstPie: props.gameState.firstPie,
                  firstLikert2Sides: props.gameState.firstLikert2Sides,
                  firstLikert3Sides: props.gameState.firstLikert3Sides,
                })
              }>
              On to the next campaign stop!
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default GameStopsIntermediary;
